/**
 * Formats a date string based on how old it is.
 * - Less than 24 hours: Shows time (e.g., "2 hours ago", "5 minutes ago")
 * - More than 24 hours: Shows date (e.g., "Jun 5", "May 20")
 *
 * @param dateString - ISO date string to format
 * @returns Formatted date/time string
 */
export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffHours = diffMs / (1000 * 60 * 60);
  
  // If less than 24 hours, show time
  if (diffHours < 24) {
    if (diffHours < 1) {
      // Less than an hour, show minutes
      const minutes = Math.floor(diffMs / (1000 * 60));
      return minutes <= 0 ? 'Just now' : `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
    } else {
      // Show hours
      const hours = Math.floor(diffHours);
      return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
    }
  } else {
    // More than 24 hours, show date
    const options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' };
    
    // If it's a different year, include the year
    if (date.getFullYear() !== now.getFullYear()) {
      options.year = 'numeric';
    }
    
    return date.toLocaleDateString('en-US', options);
  }
}
